import { createContext } from "react";
import { IHomeContext } from "@interfaces/IHomeContext";

export const HomeContext = createContext<IHomeContext>({
    updateBackgroundHeight: undefined,
});
